import type { QueryClient } from '@tanstack/react-query';

import { getUserData } from 'shared/queries/authenticationApi';
import { uiElementPermissions } from 'shared/queries/uiElementPermissions';

import type { AuthorizedUiElement, GuardAuth, GuardPermissions } from './createRouteGuard';

export async function resolveAuthContext(
  queryClient: QueryClient
): Promise<{ auth: GuardAuth; permissions: GuardPermissions }> {
  const user = await queryClient.ensureQueryData({
    queryKey: ['userData'],
    queryFn: getUserData
  });

  const auth: GuardAuth = {
    user: user ?? null,
    isUser: !!user,
    isAdmin: user ? user.role === 'admin' : null,
    roles: user ? [user.role] : []
  };

  // An anonymous caller holds nothing. The same fail-closed direction the server takes for an unresolved
  // principal — absence must never read as "unrestricted".
  const permissions: GuardPermissions = user
    ? await queryClient.ensureQueryData({
        queryKey: ['uiElementPermissions', user.id ?? ''],
        queryFn: uiElementPermissions
      })
    : { authorizedUiElements: [] as AuthorizedUiElement[], capabilities: [] };

  return { auth, permissions };
}
